import {addErrorClass, addLoadingClass, removeLoadingClass} from "./utilities/updateClasses";
import {wrap} from "./utilities/wrap";
import {initSlidecontents} from "./slidecontent";

function setActiveClassForFilter(btn,wrapper){
    for(let btn of wrapper.querySelectorAll(".js-collectionFilter .tag")){
        btn.classList.remove("is-active");
    }
    btn.classList.add("is-active");
}

function scrollToActiveFilter() {
    const urlParams = new URLSearchParams(window.location.search);
    const groupFilter = urlParams.get('group_filter');

    if (groupFilter) {
        const activeFilter = document.querySelector(`.js-collectionFilter .tag[data-filter="${groupFilter}"]`);

        if (activeFilter) {
            const filterContainer = activeFilter.closest('.js-collectionFilter');

            if (filterContainer && filterContainer.scrollWidth > filterContainer.clientWidth) {
                const containerRect = filterContainer.getBoundingClientRect();
                const activeRect = activeFilter.getBoundingClientRect();

                const scrollLeft = activeFilter.offsetLeft - (containerRect.width / 2) + (activeRect.width / 2);

                filterContainer.scrollTo({
                    left: Math.max(0, scrollLeft),
                    behavior: 'smooth'
                });
            }

            setActiveClassForFilter(activeFilter, activeFilter.closest('.collection'));
        }
    }
}

export function initAjaxCollectionFilter(){
    scrollToActiveFilter();
    for(let btn of document.querySelectorAll(".js-collectionFilter .tag")){
        let wrapper = btn.closest(".collection");
        if(wrapper){
            let wrapperId = wrapper.getAttribute("id");
            let area = wrapper.querySelector(".collectionArea");
            if(area){
                btn.addEventListener("click",function (e){
                    e.preventDefault();
                    addLoadingClass(btn);
                    addLoadingClass(area);
                    let filterID = parseInt(btn.dataset.filter);
                    fetch("?group_filter="+filterID)
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error("Could not filter data");
                            }
                            return response.text();
                        })
                        .then((data) => {
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(data, "text/html");
                            let newWrapper = doc.getElementById(wrapperId);
                            if(newWrapper){
                                let newArea = newWrapper.querySelector(".collectionArea");
                                if(newArea){
                                    area.innerHTML = newArea.innerHTML;
                                    removeLoadingClass(btn);
                                    removeLoadingClass(area);
                                    setActiveClassForFilter(btn,wrapper);
                                    initSlidecontents();
                                    window.history.replaceState(null, null, "?group_filter="+filterID);
                                }else{
                                    console.error('Area not found');
                                }
                            }else{
                                console.error('Wrapper not found');
                            }
                        })
                        .catch((e) => {
                            console.error('Error:', e);
                            addErrorClass(btn);
                            addErrorClass(area);
                        });
                })
            }
        }
    }
}